import { create } from "@/modules/core/store"

type TemplateCategriesActions = {
  setSearchTerms: (searchTerms: string) => void
}
type TemplateCategriesState = {
  searchTerms: string
  actions: TemplateCategriesActions
}

const useTemplateCategriesStore = create<TemplateCategriesState>()((set) => ({
  searchTerms: "",
  actions: {
    setSearchTerms: (searchTerms: string) => {
      set({ searchTerms })
    },
  },
}))

export const useTemplateCategries = () => useTemplateCategriesStore((state) => state.searchTerms)
export const useTemplateCategriesActions = () => useTemplateCategriesStore((state) => state.actions)
